<template>
    <div class="notification" :class="{ 'has-text-centered': centered }">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
    withDefaults(
        defineProps<{
            centered?: boolean;
        }>(),
        {
            centered: true,
        },
    );
</script>
